import { useFeatureFlag } from '#/shared/hooks/useFeatureFlag';
import { usePaidBreakExceptionStore } from '#/shared/stores/paidBreakExceptionStore';
import { getPaidBreakExceptionFieldSelector } from '#/shared/utils/paidBreakExceptionDom';

export function useOutstandingPaidBreakAlert() {
  const { isEnabled: paidBreakExceptionIsEnabled } = useFeatureFlag('PPL-2119-paid-break-exception');

  const hasOutstandingPaidBreakExceptions = usePaidBreakExceptionStore(
    state => state.hasOutstandingPaidBreakExceptions,
  );
  const getFirstOutstandingPaidBreakExceptionDate = usePaidBreakExceptionStore(
    state => state.getFirstOutstandingPaidBreakExceptionDate,
  );

  const showOutstandingPaidBreakAlert = paidBreakExceptionIsEnabled && hasOutstandingPaidBreakExceptions();

  const scrollToFirstOutstandingPaidBreakException = () => {
    const firstDate = getFirstOutstandingPaidBreakExceptionDate();

    if (!firstDate) return;

    const firstField = document.querySelector(getPaidBreakExceptionFieldSelector(firstDate)) as HTMLElement;

    firstField?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return { showOutstandingPaidBreakAlert, scrollToFirstOutstandingPaidBreakException };
}
